export enum UserStatus {
  OFFLINE = 'offline',
  ONLINE = 'online',
  DO_NOT_DISTURB = 'do not disturb',
  IN_A_MEETING = 'in a meeting',
  AWAY = 'away',
}
